import { LifecycleStage } from "../../types/LifecycleLatencyStats";
import { getStore } from "../store/appStore";
import { AppAction } from "../types";
import { LifecycleActionKey as ActionKey } from "./ActionKeys";

/** An action that notifies us of a lifecycle change. */
export interface LifecycleChangeAction
  extends AppAction<
    ActionKey.LIFECYCLE_CHANGE_OCCURRED,
    { timing: number; lifecycleStage: LifecycleStage }
  > {}

/** Sets the session state. */
export const reportLifecycleChange = (
  lifecycleStage: LifecycleStage,
  timing: number
): LifecycleChangeAction =>
  getStore().dispatch({
    type: ActionKey.LIFECYCLE_CHANGE_OCCURRED,
    payload: { timing, lifecycleStage },
  });
